import RoomsPage from './RoomsPage';

export default RoomsPage;
